"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteAccountInfoTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.WaysteAccountInfoTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerName: typebox_1.Type.String(),
    waysteLite: typebox_1.Type.Boolean(),
    billingEnabled: typebox_1.Type.Boolean(),
});
//# sourceMappingURL=wayste-account-info-transport.js.map